<header class="mast-main-head fixed-top">

  <!-- <div class="main-header-subscriber-offer-section">
    <span>🎉 Celebratings! <strong>50k+</strong> users & <strong>2K+</strong> happy subscribers.<b routerLink="/happy-subscribers"> What's in? </b> <img class="arrow" src="assets/img/arrow-right.svg" alt=""> <img class="illus-img" src="assets/img/online-cab.png" alt=""> <img class="illus-img" src="assets/img/team-art.svg" alt=""> <img class="illus-img" src="assets/img/yoga.png" alt=""></span></div> -->

  <nav class="navbar navbar-expand-lg remove-shadow" id="mainNav">
    <div class="container">
      <a class="navbar-brand js-scroll-trigger" href="javascript:;" routerLink="/home"><img src="assets/img/logo.svg"></a>
      <button class="navbar-toggler navbar-toggler-right" type="button" data-toggle="collapse" data-target="#navbarResponsive" aria-controls="navbarResponsive" aria-expanded="false" aria-label="Toggle navigation">
      </button>
      <div class="collapse navbar-collapse" id="navbarResponsive">
        <ul class="navbar-nav ml-auto">
					<li class="nav-item">
            <a class="nav-link marketplace">How it works</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" (click)="openMarketplace()" style="cursor: pointer;">Marketplace</a>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" routerLink="/pricing">Pricing</a>
          </li>
          <li class="nav-item dropdown col-1-dropdown">
            <a class="nav-link dropdown-toggle marketplace" data-toggle="dropdown">Plugins</a>
            <div class="dropdown-menu" style="width: 200px;">
              <ul>
                <li><a style="color: #000" class="nav-link" href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">
                  <img src="assets/img/ic-figma.png" alt=""> <span>Figma</span> </a>
                  <!-- <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <g id="Icons/Navigation/Arrow Down/Black">
                      <g id="Group">
                        <path id="down_arrow" d="M18.5 9.44444L12.3274 15L6 9.57345" stroke="#b2b2b2" stroke-linecap="round" stroke-linejoin="round"/>
                      </g>
                    </g>
                  </svg> -->
                </li>
                <li><a style="color: #000" class="nav-link" href="https://crafttor.com/sketch" target="_blank">
                  <img src="assets/img/ic-sketch.png" alt=""> <span>Sketch</span> </a></li>
                <li><a style="color: #000" class="nav-link" href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">
                  <img src="assets/img/ai.png" alt="" style="width: 20px; height: 20px; margin-left: 4px;"> <span>Illustrator</span> </a></li>
              </ul>
            </div>
          </li>
          <li class="nav-item">
            <a class="nav-link marketplace" href="https://crafttor.com/blogs" target="_blank">Blog</a>
          </li>
           <li class="nav-item signup-btn">
          <a class="nav-link button" href="profile.html" data-toggle="modal" routerLink="/login">Start for free</a>
          </li>
          <li class="nav-item login-btn">
          </li>
        </ul>
      </div>
    </div>
  </nav>
</header>

<section class="mission-section">
	<div class="container">
		<div class="row">
      <div class="col-sm-5">
				<div class="inner-content">
          <h1>How it works</h1>
          <p>See how Crafttor Workspace simplifies your design process for an enhanced workflow.</p>
          <div class="btn-wrapper">
            <a class="button see-pricing" routerLink="/pricing">See pricing</a>
          </div>
				</div>
			</div>
      <div class="col-sm-1">
      </div>
			<div class="col-sm-6">
				<div class="img-box">
					<iframe src="https://www.youtube.com/embed/1EbHNKLxwzk"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="community-section how-it-works">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
				<h3>Crafttor’s Commitment to User-Centric Development</h3>
				<p>Offer seamless access to creative assets and streamlined cloud-based asset management for efficient design workflows.</p>
      </div>

      <ul>
        <li>
          <div class="plugins-white-data">
            <h4 class="figma-count-txt">Organise</h4>
            <!-- <h5>Installs</h5> -->
          </div>
        </li>

        <li>
          <div class="plugins-data">
  					<h4 class="sketch-count-txt" style="color: #ffffff;">Share</h4>
  					<!-- <h5>Support</h5> -->
          </div>
        </li>

        <li>
          <div class="plugins-white-data">
  					<h4 class="illustrator-count-txt">Collaborate</h4>
  					<!-- <h5>Marketplace</h5> -->
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections">
  <div class="container">
    <div class="row">
			<h3 class="main-how-it-works-title">Crafttor in Action: Explore Workspace & Plugins</h3>
      <div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/pZFZWKgwE00"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>E-commerce UI Design</span>
					</div>
				</div>

      </div>
      <div class="col-sm-1">
      </div>
      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">E-commerce UI Design</h3>
        <p class="feature-content-right">Discover how to effortlessly design an eye-catching e-commerce product showcase using Crafttor's plugin. With easy-to-use features and customisable templates, you can create engaging product displays that elevate your online store's visual appeal. Whether you're focusing on styling, layout, or enhancing the shopping experience, Crafttor's plugin has everything you need for a professional look.</p>
      </div>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections" style="background: none;">
  <div class="container">
    <div class="row">

      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">Kaleidoscope: by Crafttor</h3>
        <p class="feature-content-right">Check how you can easily extract new UI patterns from existing ones and repurpose them to design unique product showcases or stylish product backgrounds. This method streamlines your workflow, allowing you to maintain consistency while introducing fresh design elements.</p>
      </div>

			<div class="col-sm-1">
      </div>

			<div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/Xv_4v_CXk4g"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>Kaleidoscope Plugin</span>
					</div>
				</div>

      </div>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections" style="background: none;">
  <div class="container">
    <div class="row">

      <div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/o57dU4DF4M4"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>Iso All Plugin</span>
					</div>
				</div>

      </div>

			<div class="col-sm-1">
      </div>

      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">Iso All: by Crafttor</h3>
        <p class="feature-content-right">The Iso All plugin is a powerful Figma tool designed to streamline designers' workflow and enhance creative outputs. The plugin simplifies your tasks by converting layers and elements into isometric views with just a few clicks.</p>
      </div>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections">
  <div class="container">
    <div class="row">

      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">Download Formats</h3>
        <p class="feature-content-right">Here, users can explore how to easily download their assets in various formats, ensuring compatibility with different design tools and platforms. Users can select the format that best suits their needs, making asset management more efficient and versatile. Clear steps guide users through the process for a seamless experience.</p>
      </div>

			<div class="col-sm-1">
      </div>

			<div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/knxJinqWzqU"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>Download Formats</span>
					</div>
				</div>

      </div>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections" style="background: none;">
  <div class="container">
    <div class="row">

			<div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/sF34et8f5b0"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>Translate AI Plugin</span>
					</div>
				</div>
      </div>

      <div class="col-sm-1">
      </div>

      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">Translate AI: by Crafttor</h3>
        <p class="feature-content-right">Translate AI plugin steps in, offering a seamless solution for designers and creative professionals to translate their work effectively in umpteen languages directly within Figma. This tool is designed to help you break down language barriers with ease.</p>
      </div>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections" style="background: none;">
  <div class="container">
    <div class="row">

      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">Image to Figma: by Crafttor</h3>
        <p class="feature-content-right">Turn your images into fully editable Figma designs in just a few clicks with the Image to Figma Design plugin. Right now it's a <b>BETA</b> version.</p>
      </div>

      <div class="col-sm-1">
      </div>

      <div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/CUPj3ujteMA"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>Image to Figma Plugin</span>
					</div>
				</div>

      </div>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections" style="background: none;">
  <div class="container">
    <div class="row">

			<div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/BJxSQHcss-k"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>Bannners Plugin</span>
					</div>
				</div>
      </div>

      <div class="col-sm-1">
      </div>

      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">Bannners: by Crafttor</h3>
        <p class="feature-content-right">Unlock the ability to design custom banners in any size or shape, elevating the engagement of your creative campaigns. Resize, align, and customise your designs with precision, whether in portrait or landscape orientations. Streamline your workflow and craft professional-quality banners in minutes!</p>
      </div>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections" style="background: none;">
  <div class="container">
    <div class="row">

      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">Resizing your assets</h3>
        <p class="feature-content-right">Check the plugin demo video and give it a try to resize your assets accurately and position them correctly.</p>
      </div>

      <div class="col-sm-1">
      </div>

      <div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/tjgTd9Qfx4o"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>Resizing your assets</span>
					</div>
				</div>

      </div>
    </div>
  </div>
</section>

<section class="features-sections welcome-features-sections" style="background: none;">
  <div class="container">
    <div class="row">

			<div class="col-sm-6 feature-areas">
				<div class="video-ui">
					<iframe src="https://www.youtube.com/embed/cwiphzY8VY4"
									frameborder="0"
									allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
									allowfullscreen>
					</iframe>

					<div class="view-eye">
						<!-- <img style="width:20px;" src="assets/img/view-eye.svg" alt=""> -->
						<span>Banners Alignment</span>
					</div>
				</div>
      </div>

      <div class="col-sm-1">
      </div>

      <div class="col-sm-5 central-txt video-details-txt">
        <h3 class="header-text-right version-txt">Banners Alignment</h3>
        <p class="feature-content-right">Check the plugin demo video and give it a try to align your assets perfectly.</p>
      </div>
    </div>
  </div>
</section>

<section class="plugin-design-area">
  <div class="container">
    <div class="row">
      <ul>
        <li>
          <div class="plugin-details">
            <div class="img-txt">
              <img src="assets/img/kalei.png" alt="">
              <h2>Kaleidoscope</h2>
            </div>
            <p>Kaleidoscope plugin adds style from your photos and materials, enhancing your design appearance.</p>
            <a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank"><button type="button" name="button">Try Kaleidoscope <br><span>Get started today</span></button></a>
          </div>
        </li>

        <li>
          <div class="plugin-details">
            <div class="img-txt">
              <img src="assets/img/iso.png" alt="">
              <h2>Iso All</h2>
            </div>
            <p>Iso All seems to be a tool or feature that simplifies and enhance the creation of isometric designs.</p>
            <a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank"><button type="button" name="button">Try Iso All <br><span>Get started today</span></button></a>
          </div>
        </li>

        <li>
          <div class="plugin-details">
            <div class="img-txt">
              <img src="assets/img/trans.png" alt="">
              <h2>Translate AI</h2>
            </div>
            <p>Translate AI empowers you to effortlessly translate content within your designs using the power of AI.<br></p>
            <a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank"><button type="button" name="button">Try Translate AI <br><span>Get started today</span></button></a>
          </div>
        </li>
      </ul>
    </div>
  </div>
</section>

<section class="community-bottom-section">
  <div class="container">
    <div class="row">
      <div class="col-sm-12">
        <h1>Try Crafttor Workspace for free</h1>
        <p>Ready to streamline your workflow? Start crafting your workspace now.</p>
        <div class="btn-wrapper">
          <a class="button enterprise-buy-now" style="color: #000000;" (click)="openLetsTalkDialog(letsTalk)">Connect with us</a>
        </div>
      </div>
    </div>
  </div>
</section>

<!-- Footer -->
<footer class="site-footer">
  <div class="container">
    <div class="row">
      <div class="col-sm-3">
        <div class="coulmn-1">
  				<img src="assets/img/logo.svg">
  				<p>Digital assets management</p>
  				<a href="mailto:info@crafttor.com"><i class="fa fa-envelope" aria-hidden="true"></i> info@crafttor.com</a>
  			</div>
      </div>
      <!-- 3 -->
      <div class="col-sm-2">
        <h5>Products</h5>
        <ul class="menu">
          <li><a routerLink="/home">Workspace</a></li>
          <li><a (click)="openMarketplace()">Marketplace</a></li>
          <li><a routerLink="/features">Features</a></li>
          <li><a routerLink="/mobile-apps">Crafttor for Mobile</a></li>
<li><a routerLink="/smart-storage">Smart storage</a></li>
          <li><a routerLink="/effective-search">Effective search</a></li>

        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Plugins</h5>
        <ul class="menu">
          <li><a href="https://www.figma.com/community/plugin/902086023682633830/Crafttor" target="_blank">Figma</a></li>
          <li><a href="https://crafttor.com/sketch" target="_blank">Sketch</a></li>
          <li><a href="https://exchange.adobe.com/apps/cc/109306/crafttor-for-illustrator" target="_blank">Illustrator</a></li>
          <li><a href="https://www.figma.com/community/plugin/1408354139656199596/kaleidoscope" target="_blank">Kaleidoscope</a></li>
          <li><a href="https://www.figma.com/community/plugin/1406167507218530657/iso-all" target="_blank">Iso All</a></li>
          <li><a href="https://www.figma.com/community/plugin/1409844094149025473/translate-ai" target="_blank">Translate AI</a></li>
          <li><a href="https://www.figma.com/community/plugin/1417763374654877658/image-to-figma-design-beta" target="_blank">Image to Figma</a></li>
<li><a href="https://www.figma.com/community/plugin/1409553168281102402/bannners" target="_blank">Bannners</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Solutions</h5>
        <ul class="menu">
          <li><a routerLink="/dropbox-alternative">Dropbox alternative</a></li>
          <li><a routerLink="/google-drive-alternative">G Drive alternative</a></li>
          <li><a routerLink="/box-alternative">Box alternative</a></li>
          <li><a routerLink="/content-library">Content library</a></li>
          <li><a routerLink="/user-profiling">User Profiling</a></li>
<li><a routerLink="/approvals">Creative approvals</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Features</h5>
        <ul class="menu">
          <li><a routerLink="/features/tagging">Tagging</a></li>
          <li><a routerLink="/features/sharing">Sharing</a></li>
          <li><a routerLink="/features/versioning">Versioning</a></li>
          <li><a routerLink="/features/collaboration">Collaboration</a></li>
          <li><a routerLink="/features/integration">Integration</a></li>
        </ul>
      </div>

      <div class="col-sm-2">
        <h5>Company</h5>
        <ul class="menu">
          <li><a routerLink="/about-workspace">About Workspace</a></li>
          <li><a routerLink="/contact">Contact Us</a></li>
          <li><a routerLink="/terms">Terms & Conditions</a></li>
          <li><a routerLink="/faq">FAQ</a></li>
          <li><a routerLink="/feedbacks">Feedback</a></li>
          <li><a href="https://crafttor.com/blogs" target="_blank">Blog</a></li>
          <li><a routerLink="/our-mission">Our mission</a></li>
          <li><a routerLink="/partner-with-us">Partner with us</a></li>
        </ul>
      </div>

      <div class="col-sm-3 all-social-icons">
        <h5>Socials</h5>
        <ul class="social-icons">
          <li><a rel="nofollow" href="https://www.facebook.com/Crafttor-Studio-102023868185724/?modal=admin_todo_tour" target=”_blank”
            alt="facebook"><i class="fa fa-facebook" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://twitter.com/CrafttorS" target=”_blank” alt="twitter"><i class="fa fa-twitter" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.linkedin.com/company/crafttor/" target=”_blank” alt="linkedin"><i class="fa fa-linkedin" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.instagram.com/crafttorstudio/" target=”_blank” alt="instagram"><i class="fa fa-instagram" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.youtube.com/channel/UC6SM1D8MU7uwLVEC8uFDW-w/?guided_help_flow=5" target=”_blank” alt="youtube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://dribbble.com/crafttorstudio" target=”_blank” alt="dribbble"><i class="fa fa-dribbble" aria-hidden="true"></i></a></li>
          <li><a rel="nofollow" href="https://www.behance.net/crafttorstudio" target=”_blank” alt="behance"><i class="fa fa-behance" aria-hidden="true"></i></a></li>
        </ul>
      </div>

      <div class="col-sm-12 text-center">
  			<small>&copy; 2025 Crafttor. All rights reserved</small>
  		</div>
    </div>
  </div>
</footer>

<ng-template #letsTalk let-letsTalk>
    <div class="custom-dialog custom-dialog-centered sign-up" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="letsTalk.close()">
          </button>
        <div class="modal-body">
      <h2>Let's talk!</h2>
      <p>Schedule a free demo today. We will show you a demo of how Crafttor Workspace works.</p>
      <div class="form-wrapper">
        <form class="row g-3" [formGroup]="letsTalkForm" (ngSubmit)="submitContactUs(selectDate)">
          <div class="col-md-6">
          <label class="form-label">First Name<span>*</span></label>
          <input id="textinput" formControlName="name" type="text" placeholder="Brian" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.name.touched || submitted) && letsTalkForm.controls.name.errors?.required">
          First Name is required
        </span>
          </div>
          <div class="col-md-6">
          <label class="form-label">Last Name<span>*</span></label>
          <input id="textinput" formControlName="lname" type="text" placeholder="Storm" class="form-control input-md" required>
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.lname.touched || submitted) && letsTalkForm.controls.lname.errors?.required">
          Last Name is required
        </span>
          </div>
          <div class="col-12">
          <label for="businessEmail" class="form-label">Business Email<span>*</span></label>
          <input id="textinput" formControlName="email" type="email" placeholder="abc@crafttor.com" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.required">
          Email is required
        </span>
        <span class="text-danger error-text"
        *ngIf="(letsTalkForm.controls.email.touched || submitted) && letsTalkForm.controls.email.errors?.pattern">
        Email is not valid
      </span>
          </div>
          <div class="col-12">
          <label for="company" class="form-label">Company<span>*</span></label>
          <input id="textinput" formControlName="company" type="text" placeholder="Crafttor" class="form-control input-md" >
          <span class="text-danger error-text"
          *ngIf="(letsTalkForm.controls.company.touched || submitted) && letsTalkForm.controls.company.errors?.required">
          Company Name is required
        </span>
          </div>

          <div class="col-md-12" style="display: none;">
            <label class="form-label" for="textarea">Message</label>
            <input id="textinput" formControlName="message" type="text" class="form-control input-md" required>
            <span class="text-danger error-text"
            *ngIf="(letsTalkForm.controls.message.touched || submitted) && letsTalkForm.controls.message.errors?.required">
            Message is required
          </span>
          </div>


          <div class="col-12">
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!showLeaveLoader">Submit</button>
          <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="showLeaveLoader"><img src="assets/img/img-up-white.svg" alt="" style="height: 18px;"></button>
          </div>
        </form>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>


<ng-template #selectDate let-selectDate>
    <div class="custom-dialog custom-dialog-centered select-time-popup" role="document">
      <div class="modal-content">
        <div class="modal-body">
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <img src="assets/img/cross.svg" (click)="selectDate.close()">
          </button>
        <div class="modal-body">
      <h6>{{thankYouText}}</h6>
      <h6>(IST)</h6>
      <div class="form-wrapper">
        <ul class="date-listing" *ngFor="let slots of availableSlots | slice:1:5; let i = index">
          <li *ngIf="showDate">
            <div class="date-list" (click)="selectDateSales(slots.date, slots.day, slots.month)">
              <!-- <div class="date-list-day" style="background: #f9f9f9">
                <a href="javascript:;">{{slots.day}}</a>
              </div> -->
              <div class="">
                <a href="javascript:;">{{slots.month}} {{slots.date1}}</a>
              </div>
              <!-- <a href="javascript:;">{{slots.month}}</a> -->
            </div>
          </li>
        </ul>

        <div *ngIf="!showDate" class="selected-date">
          <div class="date-list-days">
            <a href="javascript:;">{{shownDay}}</a>
          </div>
          <div style="padding-top:10px;" class="">
            <a href="javascript:;">{{shownDate}}</a>
          </div>
          <!-- <a href="javascript:;">{{shownMonth}}</a> -->
        </div>

        <p *ngIf="!showDate" (click)="changeDate()" class="change-date-txt">Change Date</p>

        <h6 style="margin-top:20px;" *ngIf="showTime">What time works?</h6>

        <ul *ngFor="let time of availableTimeSlots; let i = index">
          <li *ngIf="showTime">
            <div class="time-list" (click)="selectTimeSales(time)">
              <div style="text-align: center;" class="">
                <a href="javascript:;">{{time}}</a>
              </div>
            </div>
          </li>
        </ul>
        <div *ngIf="showFinalTime" style="text-align: center;" class="selected-time">
          <a href="javascript:;">{{shownTime}}</a>
        </div>
        <p *ngIf="!showTime" (click)="changeTime()" class="change-time-txt"></p>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="!timeSelected && dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" *ngIf="timeSelected && !dateSelected && showSubmitBtn" (click)="contactSalesCall(thankyou)">Submit</button>
        <button id="singlebutton" name="singlebutton button" class="btn btn-primary" (click)="contactSalesCall(thankyou); selectDate.close()" *ngIf="timeSelected && dateSelected && showSubmitBtn">Submit</button>
        <p *ngIf="showSelectionMessage" class="text-danger error-text" style="text-align: center; margin-top:10px; font-weight: 600">{{showSelectedMsg}}</p>
      </div>
      <p>By Submiting the form, You agree to our <a routerLink="/terms" target="_blank">Terms of Service</a> and acknowledge our <a routerLink="/terms" target="_blank">Privacy Policy</a>.</p>
        </div>
      </div>
    </div>
    </div>
</ng-template>

<ng-template #showloader let-showloader>
  <div class="custom-dialog custom-dialog-centered show-loader" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <img class="main-loader-img" style="margin-top: 200px; width: 180px;" src="assets/img/loader.svg" alt="">
        <h6 style="font-size: 16px;">Please wait</h6>
        <p>Confirming your meeting time..</p>
      </div>
  </div>
</div>
</ng-template>


<ng-template #thankyou let-thankyou>
  <div class="custom-dialog custom-dialog-centered thanks-popup" role="document">
    <div class="modal-content">
      <div class="modal-body">
        <h5>Thank you <br>Your meeting is confirmed. </h5>
          <div class="conver-grid">
            <div class="img-wrapper">
              <img src="" >
              <img src="assets/img/tick.png" class="tick">
            </div>
          <p>You are meeting with</p>
          <h4>Sandeep Virk</h4>
          </div>
      <div class="invitation-wrapper">
        <div class="">You will receive a meeting invitation shortly</div>
          <table>
          <tbody>
            <tr>
              <th>Event</th>
              <td>Crafttor intro with Sandeep</td>
            </tr>
            <!-- <tr>
              <th>Time</th>
              <td>Friday, Oct 22nd, 08:30PM - 9:00PM IST</td>
            </tr> -->
            <tr>
              <th>Guest</th>
              <td>{{userName}}<span><a>{{userEmail}}</a></span></td>
            </tr>
          </tbody>
        </table>
      </div>
      <button id="singlebutton" name="singlebutton button" class="btn btn-primary" style="width: 100%;
    margin-top: 20px;" (click)="closeThankDialog()">Close</button>
    </div>
  </div>
</div>
</ng-template>

<div
	style="width: 100%;
	background-color: rgba(0,0,0, .9);
  padding-top:200px;"
  class="modal"
  tabindex="-1"
  role="dialog"
  [ngStyle]="{'display':sendingProcessStyle}">
	<div class="modal-dialog-style modal-dialog-centered-style" role="document" style="height: 100px;
    width: 35%; margin: 0 auto; text-align: center;">
		<div class="modal-content" style="padding: 30px; background-color: rgb(255,255,255); border-radius: 10px;">
			<div class="modal-body">
				<img class="main-loader-img" style="width: 140px;" src="assets/img/loader.svg" alt="">
			  <h6 style="font-size: 16px;">Please wait</h6>
			  <p>Confirming your meeting time..</p>
			</div>
		</div>
	</div>
</div>
